import { render, staticRenderFns } from "./PackageButton.vue?vue&type=template&id=69f5352c"
import script from "./PackageButton.vue?vue&type=script&lang=js"
export * from "./PackageButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports